import Route from '@ember/routing/route';

export default class ProgressRoute extends Route {}
